import { NotificationRepository } from '../repositories/NotificationRepository';
import { logger } from '@/src/core/utils';

export class MarkNotificationReadUseCase {
  constructor(private notificationRepository: NotificationRepository) {}

  async execute(notificationId: string): Promise<void> {
    logger.debug('MarkNotificationRead', 'Marking notification as read', { notificationId });
    await this.notificationRepository.markAsRead(notificationId);
  }
}
